import async from "../components/Async";
import { getMarket } from "../services/api";

import {
  Grid as GridIcon,
  Layout as LayoutIcon,
  Users as UsersIcon,
  BookOpen as BookOpenIcon,
  Users,
  Cloud,
  DollarSign,
  Moon,
  Folder,
  PenTool,
  Code,
  Speaker,
  MessageCircle,
  Thermometer, Trello, Star, Octagon, Gift, Phone, Eye, CreditCard, ExternalLink, Key, Flag, Globe, UserCheck, Sunrise, ShoppingCart,
  Archive,
  Activity,
  RefreshCw,
  Layers,
  Sliders,
  Shield,
  Award,
  Tag, TrendingUp, Film, Send, FileText, Calendar, ShoppingBag } from "react-feather";

// Pages
import Settings from "../pages/pages/Settings";
import Logout from "../components/Logout";
import SignIn from "../pages/auth/SignIn";
import {CategoriesList} from "../components/CategoriesList";
import {ColorsList} from "../components/ColorsList";
import {BrandsList} from "../components/BrandsList";
import {MerchandsList} from "../components/MerchandsList";
import {VouchersList} from "../components/VouchersList";
import {UsersList} from "../components/UsersList";
import {ProductsList} from "../components/ProductsList";
import {AppearancePageList} from "../components/AppearancePageList";
import {NewsletterProductsPageList} from "../components/NewsletterProductsPageList";
import {NewsletterPageList} from "../components/NewsletterPageList";
import {PodcastsList} from "../components/PodcastsList";
import {NewsletterPricesPageList} from "../components/NewsletterPricesPageList";
import {NewsletterPricesGlobalPageList} from "../components/NewsletterPricesGlobalPageList";
import {AdidasVouchersList} from "../components/AdidasVouchersList";
import {ProductRatingsList} from "../components/ProductRatingsList";
import {DetailedReporting} from "../components/DetailedReportingList";
import {DeclinationHistoryPricesList} from "../components/DeclinationHistoricPrice";
import {DetailedUserDataList} from "../components/DetailedUserDataList";
import {AppearanceAthletismePageList} from "../components/AppearanceAthletismePageList";
import {DetailedUserClientDataList} from "../components/DetailedUserClientDataList";
import {FrontUsersList} from "../components/FrontUsersList";
import {GamesList} from "../components/GamesList";
import {RewardsList} from "../components/RewardsList";
import {PushNotificationsList} from "../components/PushNotificationsList";
import {CoinsList} from "../components/CoinsList";
import {DynamicLinksList} from "../components/DynamicLinksList";
import {ProductsFeedList} from "../components/ProductsFeedList";
import {DetailedProductsReporting} from "../components/DetailedProductsReportingList";
import {LandingPagesList} from "../components/LandingPagesList";
import {LandingPagesContentList} from "../components/LandingPagesContentList";
import {PushNotificationsSentList} from "../components/PushNotificationsSentList";
import {MerchantPlacesList} from "../components/MerchantPlaceList";
import {VouchersInfoList} from "../components/VouchersInfoList";
import {FrontUsersFavoritesList} from "../components/FrontUsersFavoritesList";
import {LanguagesList} from "../components/LanguagesList";
import {RacesList} from "../components/RacesList";
import {AttendeeRewardsList} from "../components/AttendeeRewardsList";
import {WheelSpinList} from "../components/WheelSpinsList";
import {WheelSpinLinksList} from "../components/WheelSpinsLinksList";
import {TestProductsUsersList} from "../components/TestProductsUsersList";
import {EventsList} from "../components/EventsList";
import {EventCapturesList} from "../components/EventCapturesList";
import {AttendeeEventsList} from "../components/AttendeeEventsList"
import {StravaAthleteList} from "../components/StravaAthleteList";
import {PhysicalShopsList} from "../components/PhysicalShopsList";
import {PhysicalShopActivationsList} from "../components/PhysicalShopActivationsList";
import {PhysicalShopOptionsList} from "../components/PhysicalShopOptionsList";

import { QRCodesList } from "../components/QRCodesList";
import {ForecastsList} from "../components/ForecastsList";
import { ForecastContentsList } from "../components/ForecastContentsList";
import { ForecastAthletesList } from "../components/ForecastAthletesList";
import { ForecastContentResultsList } from "../components/ForecastContentResultsList";
import { FriendsReferredList } from "../components/FriendsReferredList";
import { ForecastLeaguesList } from "../components/ForecastLeaguesList";
import { AttendeeLeaguesList } from "../components/AttendeeForecastsList";
import { AmbassadorAppliedUsersList } from "../components/AmbassadorAppliedUsersList";
import { AmbassadorApprovedUsersList } from "../components/AmbassadorApprovedUsersList";
import { AmbassadorRewardsList } from "../components/AmbassadorRewardsList";
import { ProductsLaunchingList } from "../components/ProductsLaunchingList";
import { ProductsSponsoringList } from "../components/ProductsSponsoringList";
import { AdvertisingPageList } from "../components/AdvertisingPageList";
import { LandingPageBrandsList } from "../components/LandingPageBrandsList";
import { LandingPageGlobalProductsList } from "../components/LandingPageGlobalProductsList";
import { ShoeRotationWidgetsList } from "../components/ShoeRotationWidgetsList";
import { ChallengesList } from "../components/ChallengesList";
import { ChallengeShopPage } from "../components/ChallengeShopPage";
import { AffiliateList } from "../components/AffiliateList";
import { AffiliateBillingList } from "../components/AffiliateBillingList";
import { AffiliateBoostList } from "../components/AffiliateBoostList";
import Importers from "../pages/importers";
import { ExperimentsList } from "../pages/experiments/ExperimentsList";
import { ExperimentsJournal } from "../pages/experiments/ExperimentsJournal";
import { ExperimentResults } from "../pages/experiments/ExperimentResults";
import { SurfaceConfig } from "../pages/experiments/SurfaceConfig";
import { StoryStudio } from "../pages/studio/StoryStudio";
import { StoryHistory } from "../pages/studio/StoryHistory";
import { TemplatesList } from "../pages/whatsapp/TemplatesList";
import { TemplateEditor } from "../pages/whatsapp/TemplateEditor";
import { CampaignsList } from "../pages/whatsapp/CampaignsList";
import { CampaignForm } from "../pages/whatsapp/CampaignForm";
import { CampaignResults } from "../pages/whatsapp/CampaignResults";
import { ContactsList } from "../pages/whatsapp/ContactsList";
import { Stats as WhatsAppStats } from "../pages/whatsapp/Stats";
import { SecurityOverview } from "../pages/security/SecurityOverview";
import { SecurityJournal } from "../pages/security/SecurityJournal";
import { Alarms } from "../pages/security/Alarms";
import { Configs as PartnerReportConfigs } from "../pages/partner-reports/Configs";
import { ReportsList as PartnerReportsList } from "../pages/partner-reports/ReportsList";
import { ReportEditor as PartnerReportEditor } from "../pages/partner-reports/ReportEditor";
import { Spaces as DisplaySpaces } from "../pages/display-spaces/Spaces";
import { Planning as DisplayPlanning } from "../pages/display-spaces/Planning";
import { Bookings as DisplayBookings } from "../pages/display-spaces/Bookings";
import { BillingRequests as DisplayBillingRequests } from "../pages/display-spaces/BillingRequests";
import { PriceBenchmarks } from "../pages/pricing/PriceBenchmarks";
import { SalesTrends } from "../pages/dashboards/SalesTrends";

// Dashboards
const Default = async(() => import("../pages/dashboards/Default"));

const dashboardRoutes = {
  path: "/",
  name: "Accueil",
  badgeColor: "primary",
  icon: LayoutIcon,
  containsHome: true,
  component: Default
};

const dashboardAthletismeRoutes = {
  path: "/athletisme",
  name: "Accueil",
  badgeColor: "primary",
  icon: LayoutIcon,
  containsHome: true,
  component: Default
};

const dashboardTrailRoutes = {
  path: "/trail",
  name: "Accueil",
  badgeColor: "primary",
  icon: LayoutIcon,
  containsHome: true,
  component: Default
};

const dashboardRunningRoutes = {
  path: "/running",
  name: "Accueil",
  badgeColor: "primary",
  icon: LayoutIcon,
  containsHome: true,
  component: Default
};

const loginRoutes = {
  path: "/login",
  name: "Connexion",
  badgeColor: "primary",
  icon: LayoutIcon,
  containsHome: true,
  component: SignIn
};

const detailedReportingRoutes = {
  path: "/detailed-reporting",
  name: "Reporting détaillé",
  icon: Thermometer,
  children: [
    {
      path: "/detailed-reporting/transactions",
      name: "Transactions",
      component: DetailedReporting
    },
    {
      path:"/detailed-reporting/products",
      name: "Produits les plus vendus",
      component: DetailedProductsReporting
    },
    {
      path: "/detailed-reporting/users",
      name: "Pages visionnées",
      component: DetailedUserDataList
    },
    {
      path: "/detailed-reporting/users-clients",
      name: "Pages visionnées (clients)",
      component: DetailedUserClientDataList
    },
  ]
};

const declinationHistoryPriceRoutes = {
  path: "/declination-history-prices",
  name: "Historique des prix",
  icon: Trello,
  component: DeclinationHistoryPricesList,
};

const pageRoutes = {
  path: "/products",
  name: "Produits",
  icon: GridIcon,
  children: [
    {
      path: "/products/shoes",
      name: "Chaussures",
      component: ProductsList
    },
    {
      path: "/products/spikes",
      name: "Pointes",
      component: ProductsList
    },
    {
      path: "/products/apparel",
      name: "Vêtements",
      component: ProductsList
    },
    {
      path: "/products/accessories",
      name: "Accessoires",
      component: ProductsList
    },
    {
      path: "/products/nutrition",
      name: "Diététique",
      component: ProductsList
    },
    {
      path: "/products/electronic",
      name: "Électronique",
      component: ProductsList
    },
    {
      path: "/products/vouchers",
      name: "Cartes cadeau",
      component: ProductsList
    },
    {
      path: "/products/triathlon",
      name: "Triathlon",
      component: ProductsList
    },
  ]
};

const categoryRoutes = {
  path: "/category",
  name: "Catégories",
  icon: BookOpenIcon,
  children: [
      {
        path: "/category/shoes",
        name: "Chaussures",
        component: CategoriesList
      },
      {
        path: "/category/spikes",
        name: "Pointes",
        component: CategoriesList
      },
      {
        path: "/category/apparel",
        name: "Vêtements",
        component: CategoriesList
      },
      {
        path: "/category/accessories",
        name: "Accessoires",
        component: CategoriesList
      },
      {
        path: "/category/nutrition",
        name: "Diététique",
        component: CategoriesList
      },
      {
        path: "/category/electronic",
        name: "Électronique",
        component: CategoriesList
      },
      {
        path: "/category/vouchers",
        name: "Cartes cadeau",
        component: CategoriesList
      },
      {
        path: "/category/triathlon",
        name: "Triathlon",
        component: CategoriesList
      },
    ]
};

const declinaisonsRoutes = {
  path: "/declinaison",
  name: "Déclinaisons",
  icon: Moon,
  children: [
    {
      path: "/declinaison/colors",
      name: "Coloris",
      component: ColorsList
    },
    {
      path: "/declinaison/brands",
      name: "Marques",
      component: BrandsList
    },
    {
      path: "/declinaison/languages",
      name: "Langues",
      component: LanguagesList
    },

  ]
};

const usersRoutes = {
  path: "/users",
  name: "Utilisateurs",
  icon: Users,
  restricted: "superadmin",
  component: UsersList,
};

const physicalShopsRoutes = {
  path: "/physical-shop",
  name: "Magasins Physiques",
  icon: ShoppingCart,
  children: [
    {
      path: "/physical-shop/list",
      name: "Liste",
      component: PhysicalShopsList
    },
    {
      path: "/physical-shop/activations",
      name: "Activations",
      component: PhysicalShopActivationsList
    },
    {
      path: "/physical-shop/options",
      name: "Offres",
      component: PhysicalShopOptionsList
    }
  ]
};

const merchandsRoutes = {
  path: "/merchands",
  name: "Sites marchands",
  icon: Cloud,
  component: MerchandsList,
};

const importersRoutes = {
  path: "/importers",
  name: "Imports produits",
  icon: RefreshCw,
  component: Importers,
};

const vouchersRoutes = {
  path: "/vouchers",
  name: "Coupons de réduction",
  icon: DollarSign,
  children: [
    {
      path: "/vouchers/global",
      name: "Coupons de réductions - Généraux",
      component: VouchersList
    },
    {
      path: "/vouchers/adidas",
      name: "Coupons de réductions - Adidas",
      component: AdidasVouchersList
    },
    {
      path: "/vouchers/info",
      name: "Coupons de réductions - Infos",
      component: VouchersInfoList
    }
  ]
};

const friendsReferredRoutes = {
  path: "/friends-referred",
  name: "Codes de parrainage",
  icon: Eye,
  component: FriendsReferredList,
};

const podcastsRoutes = {
  path: "/podcasts",
  name: "Podcasts",
  icon: Speaker,
  component: PodcastsList,
};

const appearanceRoutes = {
  path: "/appearance",
  name: "Apparence",
  icon: PenTool,
  children: [
    {
      path: "/appearance/home/slider",
      name: "Slider - Page d'accueil",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/banner",
      name: "Banner - Page d'accueil",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/best-products",
      name: "Produits - Page d'accueil",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/infinite-products",
      name: "Mise en avant infinie - Page d'accueil",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/profil",
      name: "Profil - Page d'accueil",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/search",
      name: "Profil - Recherche",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/search-background",
      name: "Arrière plan Profil - Recherche",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/search-category",
      name: "Catégories - Recherche",
      component: AppearancePageList
    },
    {
      path: "/appearance/home/search-category-V2",
      name: "Catégories V2 - Recherche",
      component: AppearancePageList
    }
  ]
};

// Apparence : hors marché FR, on ne garde que les sections pilotées par marché
// (Slider, Mise en avant infinie, Catégories V2).
if (getMarket() !== "fr") {
  const esAppearancePaths = [
    "/appearance/home/slider",
    "/appearance/home/infinite-products",
    "/appearance/home/search-category-V2",
  ];
  appearanceRoutes.children = appearanceRoutes.children.filter((child) =>
    esAppearancePaths.includes(child.path)
  );
}

const advertisingRoutes = {
  path: "/advertising",
  name: "Publicité",
  icon: PenTool,
  children: [
    {
      path: "/advertising/home/first",
      name: "1er bandeau - Page d'accueil",
      component: AdvertisingPageList
    },
    {
      path: "/advertising/products/first",
      name: "1er bandeau - Page produits",
      component: AdvertisingPageList
    },
    {
      path: "/advertising/home/second",
      name: "2nd bandeau - Page d'accueil",
      component: AdvertisingPageList
    },
    {
      path: "/advertising/products/second",
      name: "2nd bandeau - Page produits",
      component: AdvertisingPageList
    },
    {
      path: "/advertising/home/third",
      name: "3ème bandeau - Page d'accueil",
      component: AdvertisingPageList
    },
    {
      path: "/advertising/products/third",
      name: "3ème bandeau - Page produits",
      component: AdvertisingPageList
    },
  ]
};

const newsletterRoutes = {
  path: "/newsletter",
  name: "Newsletter",
  icon: Folder,
  children: [
    {
      path: "/newsletter/products",
      name: "Produits recherchés",
      component: NewsletterProductsPageList
    },
    {
      path: "/newsletter/prices-global",
      name: "Prix recherchés - global",
      component: NewsletterPricesGlobalPageList
    },
    {
      path: "/newsletter/prices",
      name: "Prix recherchés - détails",
      component: NewsletterPricesPageList
    },
    {
      path: "/newsletter/clients",
      name: "Mail collectés",
      component: NewsletterPageList
    }
  ]
};

const landingPagesRoutes = {
  path: "/landing-pages",
  name: "Landing Pages",
  icon: Flag,
  children: [
    {
      path: "/landing-pages",
      name: "Déclaration des pages",
      component: LandingPagesList
    },
    {
      path: "/landing-pages-content",
      name: "Contenu des pages",
      component: LandingPagesContentList
    },
    {
      path: "/landing-page-brands",
      name: "Déclaration des pages marques",
      component: LandingPageBrandsList
    },
    {
      path: "/landing-page-global-products",
      name: "Déclaration des pages franchises produits",
      component: LandingPageGlobalProductsList
    },
  ]
};

const shoeRotationWidgetsRoutes = {
  path: "/shoe-rotation-widgets",
  name: "Widgets rotation",
  icon: Layers,
  component: ShoeRotationWidgetsList,
};

const challengesRoutes = {
  path: "/challenges",
  name: "Challenges",
  icon: Award,
  component: ChallengesList,
};

const challengeShopRoutes = {
  path: "/challenge-shop",
  name: "Boutique & loterie",
  icon: ShoppingBag,
  component: ChallengeShopPage,
};

const productRatingsRoutes = {
  path: "/product-rating",
  name: "Avis produits",
  icon: MessageCircle,
  component: ProductRatingsList,
};

const profileRoutes = {
  path: "/profile",
  name: "Profile",
  icon: UsersIcon,
  component: Settings,
};

const logoutRoutes = {
  path: "/logout",
  name: "Logout",
  icon: UsersIcon,
  component: Logout,
};

const clientsRoutes = {
  path: "/clients",
  name: "Comptes clients",
  icon: Star,
  component: FrontUsersList,
};

const stravaAthleteRoutes = {
  path: "/strava-athletes",
  name: "Comptes Strava",
  icon: Sunrise,
  component: StravaAthleteList,
};

const gamesRoutes = {
  path: "/games",
  name: "Jeux Concours",
  icon: Octagon,
  component: GamesList,
};

const rewardsRoutes = {
  path: "/rewards",
  name: "Récompenses",
  icon: Gift,
  component: RewardsList,
};

const notificationsRoutes = {
  path: "/notifications",
  name: "Push Notifications",
  icon: Phone,
  children: [
    {
      path: "/notifications",
      name: "A programmer",
      component: PushNotificationsList
    },
    {
      path: "/notifications-sent",
      name: "Envoyées",
      component: PushNotificationsSentList
    },
  ]
};

const coinsRoutes = {
  path: "/coins",
  name: "TRCoins",
  icon: CreditCard,
  component: CoinsList,
};

const dynamicLinksRoutes = {
  path: "/dynamic-links",
  name: "Dynamic Links",
  icon: ExternalLink,
  component: DynamicLinksList,
};

const favoritesUsersRoutes = {
  path: "/favorites-users",
  name: "Produits favoris",
  icon: Star,
  component: FrontUsersFavoritesList,
};

const merchantPlacesRoutes = {
  path: "/merchant-place",
  name: "Offres CornerTRC",
  icon: Cloud,
  component: MerchantPlacesList,
};

const wheelsSpinRoutes = {
  path: "/wheel-spin",
  name: "Roue de la fortune",
  icon: Globe,
  children: [
    {
      path: "/wheel-spin/configuration",
      name: "Configuration",
      component: WheelSpinList
    },
    {
      path: "/wheel-spin/links",
      name: "Liens générés",
      component: WheelSpinLinksList
    },
  ]
};

const physicalEventsRoutes = {
  path: "/physical-events",
  name: "Evenements physiques",
  icon: Moon,
  children: [
    {
      path: "/physical-events/list",
      name: "Liste",
      component: EventsList
    },
    {
      path: "/physical-events/attendees",
      name: "Participants",
      component: AttendeeEventsList
    },
  ]
};

// A/B testing : section « Expériences » du back-office.
const experimentsRoutes = {
  path: "/experiments",
  name: "A/B Testing",
  icon: Sliders,
  children: [
    {
      path: "/experiments/list",
      name: "Liste",
      component: ExperimentsList
    },
    {
      path: "/experiments/journal",
      name: "Journal",
      component: ExperimentsJournal
    },
    {
      path: "/experiments/surface-config",
      name: "Défauts de surface",
      component: SurfaceConfig
    },
  ]
};

// Studio Story : stories Instagram générées (captures de la vraie page + rendu Remotion).
const studioRoutes = {
  path: "/studio",
  name: "Studio Story",
  icon: Film,
  children: [
    {
      path: "/studio/new",
      name: "Nouvelle story",
      component: StoryStudio
    },
    {
      path: "/studio/history",
      name: "Historique",
      component: StoryHistory
    },
  ]
};

// Campagnes WhatsApp (SP4) : templates marketing soumis à Meta et campagnes aux contacts qui ont donné leur accord.
const whatsappRoutes = {
  path: "/whatsapp",
  name: "WhatsApp",
  icon: Send,
  children: [
    { path: "/whatsapp/templates", name: "Templates", component: TemplatesList },
    { path: "/whatsapp/campaigns", name: "Campagnes", component: CampaignsList },
    { path: "/whatsapp/contacts", name: "Contacts", component: ContactsList },
    { path: "/whatsapp/stats", name: "Stats", component: WhatsAppStats },
  ]
};

// Reportings partenaires (12/10/2026) : brouillons hebdo/mensuels générés par le robot, relus puis envoyés.
const partnerReportsRoutes = {
  path: "/partner-reports",
  name: "Reporting partenaires",
  icon: FileText,
  children: [
    { path: "/partner-reports/reports", name: "Rapports", component: PartnerReportsList },
    { path: "/partner-reports/partners", name: "Partenaires", component: PartnerReportConfigs },
  ]
};
// Espaces partenaires (15/10/2026) : catalogue des espaces de display, planning, contrats cadres.
const displaySpacesRoutes = {
  path: "/display-spaces",
  name: "Espaces partenaires",
  icon: Calendar,
  children: [
    { path: "/display-spaces/planning", name: "Planning", component: DisplayPlanning },
    { path: "/display-spaces/bookings", name: "Réservations", component: DisplayBookings },
    { path: "/display-spaces/billing-requests", name: "Coordonnées à valider", component: DisplayBillingRequests },
    { path: "/display-spaces/spaces", name: "Espaces", component: DisplaySpaces },
  ]
};

// Éditeur : hors menu (route paramétrée), ajouté au seul routeur.
const partnerReportEditorRoute = { path: "/partner-reports/report/:partner/:period", name: "Rapport partenaire", component: PartnerReportEditor };

// Pages de détail WhatsApp : hors menu (routes paramétrées), ajoutées au seul routeur.
const whatsappTemplateRoute = { path: "/whatsapp/template/:name/:language", name: "Template WhatsApp", component: TemplateEditor };
const whatsappCampaignResultsRoute = { path: "/whatsapp/campaign/:id/results", name: "Résultats de campagne", component: CampaignResults };
const whatsappCampaignRoute = { path: "/whatsapp/campaign/:id", name: "Campagne WhatsApp", component: CampaignForm };

// Page d'une story : hors menu (route paramétrée), ajoutée au seul routeur.
const studioStoryRoute = {
  path: "/studio/story/:id",
  name: "Story",
  component: StoryStudio
};

// Route de détail volontairement HORS du menu : la sidebar rend tous les
// enfants d'une section, une route paramétrée y apparaîtrait telle quelle.
// Elle est donc déclarée à part et ajoutée au seul routeur (allRoutes).
const experimentResultsRoute = {
  path: "/experiments/results/:id",
  name: "Résultats d'expérience",
  component: ExperimentResults
};

// Surveillance sécurité : agrégats du robot `security-watch` (WAF, APIs,
// connexions, GuardDuty/CloudTrail) et blocage d'IP.
const securityRoutes = {
  path: "/security",
  name: "Sécurité",
  icon: Shield,
  children: [
    {
      path: "/security/overview",
      name: "Vue d'ensemble",
      component: SecurityOverview
    },
    {
      path: "/security/journal",
      name: "Journal",
      component: SecurityJournal
    },
    {
      path: "/security/alarms",
      name: "Alarmes",
      component: Alarms
    },
  ]
};

// Position de notre meilleur prix face au prix de référence Google Shopping
// (rapport « Compétitivité des prix » du Merchant Center, importé chaque matin).
const priceBenchmarksRoutes = {
  path: "/price-benchmarks",
  name: "Prix vs marché",
  icon: Tag,
  component: PriceBenchmarks
};

// Tendances d'achat : rythme des conversions par mois, jour, jour de semaine et
// jour du mois (table sales_daily_stats, lambda sales-daily-stats).
const salesTrendsRoutes = {
  path: "/sales-trends",
  name: "Tendances d'achat",
  icon: TrendingUp,
  component: SalesTrends
};

const eventCapturesRoutes = {
  path: "/event-captures",
  name: "Captation salons",
  icon: Flag,
  children: [
    {
      path: "/event-captures/list",
      name: "Liste",
      component: EventCapturesList
    },
  ]
};

const forecastsRoutes = {
  path: "/forecasts",
  name: "Pronostics",
  icon: Moon,
  children: [
    {
      path: "/forecasts/list",
      name: "Liste",
      component: ForecastsList
    },
    {
      path: "/forecasts/athletes",
      name: "Athlètes",
      component: ForecastAthletesList
    },
    {
      path: "/forecasts/contents",
      name: "Épreuves",
      component: ForecastContentsList
    },
    {
      path: "/forecasts/results",
      name: "Résultats",
      component: ForecastContentResultsList
    },
    {
      path: "/forecasts/attendees",
      name: "Participants",
      component: AttendeeLeaguesList,
    },
    {
      path: "/forecasts/leagues",
      name: "Ligues",
      component: ForecastLeaguesList
    },
    
  ]
};

const productsLaunchingRoutes = {
  path: "/products-launching",
  name: "Lancement Produits",
  icon: Activity,
  component: ProductsLaunchingList,
};

const productsSponsoringRoutes = {
  path: "/products-sponsoring",
  name: "Sponsoring Produits",
  icon: Activity,
  component: ProductsSponsoringList,
};

const testProductsUsersRoutes = {
  path:"/testing-clients",
  name: "Testing produits",
  icon: UserCheck,
  component: TestProductsUsersList
}

const racesRoutes = {
  path: "/races",
  name: "Courses",
  icon: Flag,
  component: RacesList,
};

const qrCodesRoutes = {
  path: "/qr-codes",
  name: "QRCodes",
  icon: Code,
  component: QRCodesList,
};

const attendeeRewardsRoutes = {
  path: "/attendee-rewards",
  name: "Récompenses à envoyer",
  icon: Gift,
  component: AttendeeRewardsList,
}

const ambassadorRoutes = {
  path: "/ambassador",
  name: "Ambassadeurs",
  icon: Archive,
  children: [  
    {
      path: "/ambassador/approved",
      name: "Actifs",
      component: AmbassadorApprovedUsersList
    },
    {
      path: "/ambassador/applied",
      name: "Candidatures",
      component: AmbassadorAppliedUsersList
    },
    {
      path: "/ambassador/rewards",
      name: "Récompenses",
      component: AmbassadorRewardsList
    },
  ]
};

const affiliateRoutes = {
  path: "/affiliate",
  name: "Affiliés",
  icon: Archive,
  children: [  
    {
      path: "/affiliate/affiliates",
      name: "Affiliés",
      component: AffiliateList
    },
    {
      path: "/affiliate/billing",
      name: "Facturation",
      component: AffiliateBillingList
    },
    {
      path: "/affiliate/boosts",
      name: "Boosts",
      component: AffiliateBoostList
    },
  ]
};

// Sections réservées au marché FR : masquées (menu + accès aux pages) sur les
// autres marchés. Le filtrage est ré-évalué au chargement (la page recharge au
// changement de marché).
const frOnlyPaths = [
  "/studio",          // Studio Story (stories FR uniquement en v1)
  "/category",        // Catégories
  "/races",           // Courses
  "/declinaison",     // Déclinaisons
  "/physical-shop",   // Magasins physiques
  "/podcasts",        // Podcasts
  "/merchant-place",  // Offres CornerTRC
  "/forecasts",       // Pronostics
  "/testing-clients", // Testing produits
  "/dynamic-links",   // Dynamic Links
  "/newsletter",      // Newsletter
  "/favorites-users", // Produits favoris
  "/qr-codes",        // QR Code
  "/users",           // Utilisateurs
];

const forMarket = (list) =>
  getMarket() === "fr" ? list : list.filter((route) => !frOnlyPaths.includes(route.path));

// Barre latérale : tableaux de bord en tête (ordre d'origine), puis toutes les
// sections triées par nom (ordre alphabétique français, accents ignorés).
const byName = (a, b) =>
  String(a.name || "").localeCompare(String(b.name || ""), "fr", { sensitivity: "base" });
const isHome = (route) =>
  route.name === "Accueil" || route.path === "/" || String(route.path || "").startsWith("/dashboard");
const sortSidebar = (list) => {
  const dashboards = list.filter(isHome);
  const others = list.filter((route) => !isHome(route));
  return [...dashboards, ...[...others].sort(byName)];
};

// Dashboard specific routes
export const allRoutes = sortSidebar(forMarket([
  dashboardRoutes,
  dashboardAthletismeRoutes,
  dashboardTrailRoutes,
  dashboardRunningRoutes,
  experimentsRoutes,
  detailedReportingRoutes,
  pageRoutes,
  categoryRoutes,
  declinaisonsRoutes,
  merchandsRoutes,
  importersRoutes,
  physicalShopsRoutes,
  friendsReferredRoutes,
  vouchersRoutes,
  productsLaunchingRoutes,
  landingPagesRoutes,
  shoeRotationWidgetsRoutes,
  challengesRoutes,
  challengeShopRoutes,
  wheelsSpinRoutes,
  usersRoutes,
  clientsRoutes,
  stravaAthleteRoutes,
  physicalEventsRoutes,
  eventCapturesRoutes,
  testProductsUsersRoutes,
  appearanceRoutes,
  newsletterRoutes,
  notificationsRoutes,
  podcastsRoutes,
  logoutRoutes,
  profileRoutes,
  productRatingsRoutes,
  racesRoutes,
  attendeeRewardsRoutes,
  gamesRoutes,
  rewardsRoutes,
  coinsRoutes,
  dynamicLinksRoutes,
  favoritesUsersRoutes,
  merchantPlacesRoutes,
  qrCodesRoutes,
  forecastsRoutes,
  advertisingRoutes,
  ambassadorRoutes,
  affiliateRoutes,
  productsSponsoringRoutes,
  securityRoutes,
  priceBenchmarksRoutes,
  salesTrendsRoutes,
  studioRoutes,
  experimentResultsRoute,
  studioStoryRoute,
  whatsappRoutes,
  whatsappTemplateRoute,
  partnerReportsRoutes,
  displaySpacesRoutes,
  partnerReportEditorRoute,
  whatsappCampaignResultsRoute,
  whatsappCampaignRoute,
]));

// Dashboard specific routes
export const dashboardAll = sortSidebar(forMarket([
  dashboardRoutes,
  experimentsRoutes,
  studioRoutes,
  whatsappRoutes,
  partnerReportsRoutes,
  displaySpacesRoutes,
  affiliateRoutes,
  ambassadorRoutes,
  appearanceRoutes,
  productRatingsRoutes,
  categoryRoutes,
  clientsRoutes,
  stravaAthleteRoutes,
  friendsReferredRoutes,
  vouchersRoutes,
  racesRoutes,
  declinaisonsRoutes,
  dynamicLinksRoutes,
  physicalEventsRoutes,
  eventCapturesRoutes,
  importersRoutes,
  gamesRoutes,
  productsLaunchingRoutes,
  landingPagesRoutes,
  shoeRotationWidgetsRoutes,
  challengesRoutes,
  challengeShopRoutes,
  physicalShopsRoutes,
  newsletterRoutes,
  merchantPlacesRoutes,
  podcastsRoutes,
  pageRoutes,
  notificationsRoutes,
  favoritesUsersRoutes,
  forecastsRoutes,
  advertisingRoutes,
  qrCodesRoutes,
  rewardsRoutes,
  attendeeRewardsRoutes,
  securityRoutes,
  priceBenchmarksRoutes,
  salesTrendsRoutes,
  detailedReportingRoutes,
  wheelsSpinRoutes,
  merchandsRoutes,
  productsSponsoringRoutes,
  testProductsUsersRoutes,
  coinsRoutes,
  usersRoutes,
]));

// Landing specific routes
export const landing = [loginRoutes];

// Auth specific routes

// All routes
export default sortSidebar(forMarket([
  dashboardRoutes,
  dashboardAthletismeRoutes,
  dashboardRunningRoutes,
  dashboardTrailRoutes,
  detailedReportingRoutes,
  pageRoutes,
  categoryRoutes,
  declinaisonsRoutes,
  merchandsRoutes,
  importersRoutes,
  physicalShopsRoutes,
  friendsReferredRoutes,
  vouchersRoutes,
  usersRoutes,
  physicalEventsRoutes,
  eventCapturesRoutes,
  testProductsUsersRoutes,
  appearanceRoutes,
  newsletterRoutes,
  notificationsRoutes,
  podcastsRoutes,
  logoutRoutes,
  profileRoutes,
  productRatingsRoutes,
  clientsRoutes,
  stravaAthleteRoutes,
  gamesRoutes,
  racesRoutes,
  rewardsRoutes,
  coinsRoutes,
  dynamicLinksRoutes,
  merchantPlacesRoutes,
  qrCodesRoutes,
  forecastsRoutes,
  advertisingRoutes,
  ambassadorRoutes,
  affiliateRoutes,
  productsLaunchingRoutes,
  productsSponsoringRoutes,
]));
